import React, { useState } from "react";
import { Slider } from "antd";
import ButtonPrev5s from "./component/button_prev_5s";
import ButtonNext5s from "./component/button_next_5s";
import ButtonPlay from "./component/button_play";
import ButtonPrev from "./component/button_prev";
import ButtonNext from "./component/button_next";
import TriggerPlay from "./trigger/trigger_play";
import TriggerInit from "./trigger/trigger_init";
import TriggerMonitor from "./trigger/trigger_monitor";
import useActionDialogRefine from "hook/bailiff/dialog/useActionDialog";
import { refineTimer } from "util/refine_timer.function";
import TriggerOver from "./trigger/trigger_over";
import TriggerChange from "./trigger/trigger_change";
import moment from "moment";
import { FLOWS, useFlow } from "hook/bailiff/document/flow/useFlow";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogAudioBottom = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  const isFlow = flow === FLOWS.PAID;
  const { start, second, duration } = useActionDialogRefine();
  // -------------------------- STATE ---------------------------
  const [audio, setAudio] = useState(null);
  const [trigger, setTrigger] = useState(null);
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChange = (value) => {
    const id = `change-${moment()?.valueOf()}-${value}`;
    setTrigger(id);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderDuration = () => {
    const current = Number(second?.toFixed(0));
    const to = Number(duration?.toFixed(0));
    const labelStart = refineTimer({ timer: current });
    const labelDuration = refineTimer({ timer: to });
    return (
      <div className="flex w-full items-center gap-3">
        <span className="flex min-w-[90px] flex-[0.05] flex-row justify-end font-montserrat text-[12px] text-gray-500">
          {labelStart}
        </span>
        <div className="flex-[0.9]">{renderProgress()}</div>
        <span className="min-w-[90px] flex-[0.05] font-montserrat text-[12px] text-gray-500">
          {labelDuration}
        </span>
      </div>
    );
  };

  const renderProgress = () => {
    return (
      <Slider
        value={second}
        min={start}
        max={duration}
        step={0.01}
        tooltip={false}
        onChange={handleChange}
      />
    );
  };

  const renderControl = () => {
    return (
      <div className="flex items-center justify-center gap-[8px]">
        <ButtonPrev5s />
        <ButtonPrev />
        <ButtonPlay />
        <ButtonNext />
        <ButtonNext5s />
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-[99] min-h-[80px] border-t-[1px] border-gray-200 bg-white p-[8px]">
        <div className="mx-auto flex max-w-[100%] flex-col gap-[4px]">
          {renderDuration()}
          {renderControl()}
        </div>
      </div>
      <TriggerPlay audio={audio} />
      <TriggerMonitor audio={audio} />
      <TriggerInit setAudio={setAudio} />
      <TriggerOver
        start={start}
        end={duration}
        audio={audio}
        setTrigger={setTrigger}
      />
      <TriggerChange audio={audio} trigger={trigger} />
    </>
  );
};
export default DialogAudioBottom;
